/* =============================================================================
 * Sequoia Product Quiz — scoring engine + UI
 * Vanilla ES6. No dependencies.
 * ---------------------------------------------------------------------------
 * The recommendation is ALWAYS calculated from the scores below.
 * Nothing is hardcoded. Edit data/scores in QUIZ_DATA, not the engine.
 * ========================================================================== */

(function () {
  "use strict";

  /* ---------------------------------------------------------------------------
   * 1. CONFIG — fallback URLs + placeholder image.
   *    Real product data (image/title/price/url) comes from Shopify via the
   *    section's JSON block. These URLs are used only if Shopify has none.
   * ------------------------------------------------------------------------ */
  const PRODUCT_URLS = {
    HN: "",
    PROBIOTICS: "",
    DTX: "",
    BCOMPLEX: "",
    IRON: "",
    BUNDLE: "",
  };

  const PLACEHOLDER_IMAGE =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="480" height="480">' +
        '<rect width="100%" height="100%" fill="#ece9e3"/>' +
        '<text x="50%" y="50%" font-family="Arial" font-size="22" fill="#b3ae a3" ' +
        'text-anchor="middle" dy=".35em">Sequoia</text></svg>'
    );

  /* ---------------------------------------------------------------------------
   * 2. QUIZ DATA — questions, options, scoring.
   *    Each option: { label, scores:{PRODUCT:points}, branch?, saveText? }
   *    saveText on a QUESTION means it does not change the score, only the
   *    recommendation text.
   * ------------------------------------------------------------------------ */
  const QUIZ_DATA = {
    intro: {
      title: "מצאי את המוצר שמתאים בדיוק לך",
      subtitle:
        "עני על מספר שאלות קצרות ונמצא עבורך את ההתאמה האישית ביותר.",
      cta: "התחילי",
    },

    goal: {
      id: "goal",
      text: "מה המטרה העיקרית שלך?",
      type: "single",
      options: [
        { label: "שיער חזק ובריא", scores: { HN: 4 }, branch: "hair" },
        { label: "פחות נפיחות", scores: { PROBIOTICS: 4 }, branch: "bloating" },
        { label: "יותר אנרגיה", scores: { BCOMPLEX: 4 }, branch: "energy" },
        {
          label: "תמיכה באיזון ובתהליכי הניקוי",
          scores: { DTX: 4 },
          branch: "balance",
        },
      ],
    },

    categories: {
      /* -------- Category 1: שיער (HN) -------- */
      hair: [
        {
          id: "hair_1",
          text: "מה הכי מפריע לך כרגע בשיער?",
          type: "single",
          options: [
            { label: "נשירה מוגברת", scores: { HN: 2 } },
            { label: "שיער דק וחלש", scores: { HN: 2 } },
            { label: "שיער שנשבר בקלות", scores: { HN: 2 } },
            { label: "צמיחה איטית או חוסר חיוניות", scores: { HN: 2 } },
          ],
        },
        {
          id: "hair_2",
          text: "כמה זמן את מרגישה שינוי במצב השיער?",
          type: "single",
          options: [
            { label: "פחות מחודש", scores: { HN: 1 } },
            { label: "חודש עד שלושה חודשים", scores: { HN: 1 } },
            { label: "יותר משלושה חודשים", scores: { HN: 2 } },
            { label: "זו תופעה שחוזרת בתקופות שונות", scores: { HN: 2 } },
          ],
        },
        {
          id: "hair_3",
          text: "האם את חווה במקביל אחד מהדברים הבאים?",
          type: "single",
          options: [
            { label: "עייפות או חולשה", scores: { BCOMPLEX: 2 } },
            { label: "ציפורניים חלשות", scores: { HN: 2 } },
            { label: "מחזור חודשי חזק", scores: { IRON: 1 } },
            { label: "אף אחד מאלה", scores: {} },
          ],
        },
        {
          id: "hair_4",
          text: "מה כבר ניסית כדי לשפר את מצב השיער?",
          type: "single",
          saveText: true,
          options: [
            { label: "תוספי תזונה", scores: {} },
            { label: "מוצרי טיפוח חיצוניים", scores: {} },
            { label: "שינוי בתזונה", scores: {} },
            { label: "עדיין לא ניסיתי פתרון קבוע", scores: {} },
          ],
        },
      ],

      /* -------- Category 2: נפיחות (PROBIOTICS) -------- */
      bloating: [
        {
          id: "bloat_1",
          text: "מתי את מרגישה את הנפיחות בעיקר?",
          type: "single",
          options: [
            { label: "מיד אחרי ארוחות", scores: { PROBIOTICS: 2 } },
            { label: "בשעות הערב", scores: { PROBIOTICS: 1 } },
            { label: "לאורך כל היום", scores: { PROBIOTICS: 2, DTX: 1 } },
            { label: "בתקופת המחזור", scores: { PROBIOTICS: 1 } },
          ],
        },
        {
          id: "bloat_2",
          text: "מה בדרך כלל מתלווה לנפיחות?",
          type: "single",
          options: [
            { label: "גזים", scores: { PROBIOTICS: 2 } },
            { label: "תחושת כבדות", scores: { DTX: 2 } },
            { label: "עצירות או יציאות לא סדירות", scores: { PROBIOTICS: 2 } },
            { label: "נפיחות ללא תסמינים נוספים", scores: { PROBIOTICS: 1 } },
          ],
        },
        {
          id: "bloat_3",
          text: "באיזו תדירות את סובלת מנפיחות?",
          type: "single",
          options: [
            { label: "פעם או פעמיים", scores: { PROBIOTICS: 1 } },
            { label: "כמה פעמים", scores: { PROBIOTICS: 2 } },
            { label: "כמעט כל יום", scores: { PROBIOTICS: 2, DTX: 1 } },
            { label: "אחרי מאכלים מסוימים", scores: { PROBIOTICS: 1 } },
          ],
        },
        {
          id: "bloat_4",
          text: "מה בדרך כלל מחמיר את הנפיחות?",
          type: "single",
          saveText: true,
          options: [
            { label: "מוצרי חלב", scores: {} },
            { label: "לחם", scores: {} },
            { label: "ארוחות גדולות", scores: {} },
            { label: "עדיין לא הצלחתי לזהות", scores: {} },
          ],
        },
      ],

      /* -------- Category 3: אנרגיה (BCOMPLEX) -------- */
      energy: [
        {
          id: "energy_1",
          text: "מתי את מרגישה את הירידה המשמעותית ביותר באנרגיה?",
          type: "single",
          options: [
            { label: "בבוקר", scores: { BCOMPLEX: 2 } },
            { label: "צהריים", scores: { BCOMPLEX: 2 } },
            { label: "ערב", scores: { BCOMPLEX: 1 } },
            { label: "כל היום", scores: { BCOMPLEX: 2 } },
          ],
        },
        {
          id: "energy_2",
          text: "איך חוסר האנרגיה משפיע?",
          type: "single",
          options: [
            { label: "קשה להתחיל את היום", scores: { BCOMPLEX: 2 } },
            { label: "קושי בריכוז", scores: { BCOMPLEX: 1 } },
            { label: "חולשה", scores: { BCOMPLEX: 1 } },
            { label: "תלות בקפה", scores: { BCOMPLEX: 2 } },
          ],
        },
        {
          id: "energy_3",
          text: "איך איכות השינה?",
          type: "single",
          saveText: true,
          options: [
            { label: "ישנה טוב ועדיין עייפה", scores: { BCOMPLEX: 2 } },
            { label: "מתקשה להירדם", scores: {} },
            { label: "מתעוררת בלילה", scores: {} },
            { label: "ישנה מעט", scores: {} },
          ],
        },
        {
          id: "energy_4",
          text: "האם אחד מהמצבים הבאים רלוונטי אלייך?",
          type: "single",
          options: [
            { label: "מחסור בברזל", scores: { IRON: 4 } },
            { label: "צמחונית", scores: { IRON: 1 } },
            { label: "מחזור חודשי חזק", scores: { IRON: 1 } },
            { label: "אף אחד", scores: { BCOMPLEX: 1 } },
          ],
        },
      ],

      /* -------- Category 4: איזון וניקוי (DTX) -------- */
      balance: [
        {
          id: "balance_1",
          text: "מה גורם לך להרגיש שאת זקוקה לאיזון?",
          type: "single",
          options: [
            { label: "תחושת כבדות", scores: { DTX: 2 } },
            { label: "נפיחות", scores: { PROBIOTICS: 2, DTX: 1 } },
            { label: "עור עייף", scores: { DTX: 1 } },
            { label: "תזונה פחות מאוזנת", scores: { DTX: 2 } },
          ],
        },
        {
          id: "balance_2",
          text: "איך מערכת העיכול?",
          type: "single",
          options: [
            { label: "יציאות סדירות", scores: { DTX: 1 } },
            { label: "עצירות", scores: { PROBIOTICS: 2 } },
            { label: "לא סדירות", scores: { PROBIOTICS: 2 } },
            { label: "משתנה", scores: { PROBIOTICS: 1 } },
          ],
        },
        {
          id: "balance_3",
          text: "איך התזונה?",
          type: "single",
          options: [
            { label: "מאוזנת", scores: {} },
            { label: "מעובד ומתוקים", scores: { DTX: 2 } },
            { label: "הרבה אוכל בחוץ", scores: { DTX: 2 } },
            { label: "מעט ירקות", scores: { DTX: 1 } },
          ],
        },
        {
          id: "balance_4",
          text: "איזו תוצאה הכי חשובה לך?",
          type: "single",
          options: [
            { label: "להרגיש פחות כבדה", scores: { DTX: 1, PROBIOTICS: 1 } },
            { label: "מערכת עיכול תקינה", scores: { PROBIOTICS: 2 } },
            { label: "יותר אנרגיה", scores: { BCOMPLEX: 2 } },
            { label: "לחזור לשגרה", scores: { DTX: 2 } },
          ],
        },
      ],
    },

    /* -------- Safety (shown to everyone, no scoring, multi-select) -------- */
    safety: {
      id: "safety",
      text: "האם אחד מהדברים הבאים רלוונטי אלייך?",
      type: "multi",
      disclaimerIndexes: [0, 1, 2], // any of these → show disclaimer
      options: [
        { label: "אני בהריון או מניקה", scores: {} },
        { label: "אני נוטלת תרופות", scores: {} },
        { label: "יש לי מצב רפואי", scores: {} },
        { label: "אף אחד מאלה", scores: {} },
      ],
    },

    disclaimer: "לפני השימוש מומלץ להתייעץ עם רופא או איש מקצוע.",
  };

  /* ---------------------------------------------------------------------------
   * 3. PRODUCT DISPLAY DATA (placeholders — edit copy in the theme editor).
   *    Image/title/price/url are merged from Shopify at runtime.
   * ------------------------------------------------------------------------ */
  const PRODUCT_DEFAULTS = {
    HN: {
      name: "HN — שיער וציפורניים",
      desc: "תמיכה בשיער חזק, מלא וחיוני [טקסט לעריכה].",
      why: "בחרת בשיער כמטרה העיקרית, והתשובות שלך הצביעו על צורך בתמיכה בשיער. [טקסט לעריכה]",
    },
    PROBIOTICS: {
      name: "Probiotics — איזון מערכת העיכול",
      desc: "תמיכה בעיכול תקין ובתחושת קלילות [טקסט לעריכה].",
      why: "התשובות שלך הצביעו על נפיחות ואי-נוחות בעיכול. [טקסט לעריכה]",
    },
    DTX: {
      name: "DTX — איזון וניקוי",
      desc: "תמיכה בתהליכי האיזון הטבעיים של הגוף [טקסט לעריכה].",
      why: "סימנת תחושת כבדות וצורך באיזון. [טקסט לעריכה]",
    },
    BCOMPLEX: {
      name: "B-Complex — אנרגיה",
      desc: "תמיכה ברמות האנרגיה ובתפקוד היומיומי [טקסט לעריכה].",
      why: "התשובות שלך הצביעו על ירידה באנרגיה ועייפות. [טקסט לעריכה]",
    },
    IRON: {
      name: "Iron — ברזל",
      desc: "תמיכה ברמות ברזל תקינות [טקסט לעריכה].",
      why: "סימנת מצב שמתאים לתמיכה בברזל. [טקסט לעריכה]",
    },
    BUNDLE: {
      name: "הסוף לנפיחות",
      desc: "חבילה משולבת לתמיכה בעיכול ובאיזון [טקסט לעריכה].",
      why: "השילוב של נפיחות וצורך באיזון מתאים במיוחד לחבילה הזו. [טקסט לעריכה]",
    },
  };

  /* ===========================================================================
   * 4. SCORING ENGINE
   * ======================================================================== */
  const ALL_PRODUCTS = ["HN", "PROBIOTICS", "DTX", "BCOMPLEX", "IRON"];

  function blankScores() {
    return { HN: 0, PROBIOTICS: 0, DTX: 0, BCOMPLEX: 0, IRON: 0 };
  }

  // Flat lookup: questionId -> question (for recomputing scores from answers).
  function buildQuestionIndex() {
    const idx = {};
    idx[QUIZ_DATA.goal.id] = QUIZ_DATA.goal;
    Object.keys(QUIZ_DATA.categories).forEach(function (cat) {
      QUIZ_DATA.categories[cat].forEach(function (q) {
        idx[q.id] = q;
      });
    });
    idx[QUIZ_DATA.safety.id] = QUIZ_DATA.safety;
    return idx;
  }
  const QUESTION_INDEX = buildQuestionIndex();

  // Recompute scores from scratch every time (prevents back/forward drift).
  function computeScores(answers) {
    const scores = blankScores();
    Object.keys(answers).forEach(function (qid) {
      const q = QUESTION_INDEX[qid];
      if (!q) return;
      const chosen = answers[qid]; // number (single) or array (multi)
      const indexes = Array.isArray(chosen) ? chosen : [chosen];
      indexes.forEach(function (i) {
        const opt = q.options[i];
        if (!opt || !opt.scores) return;
        Object.keys(opt.scores).forEach(function (p) {
          scores[p] += opt.scores[p];
        });
      });
    });
    return scores;
  }

  /*
   * Recommendation rules (verbatim from spec):
   *  - Sort by score, highest = main.
   *  - Second only if its score >= 4. Never more than 2.
   *  - Bundle: PROBIOTICS >= 4 AND DTX >= 4 -> show bundle instead.
   *  - Iron: only eligible if IRON >= 4 (never wins on fatigue alone).
   */
  function recommend(scores) {
    if (scores.PROBIOTICS >= 4 && scores.DTX >= 4) {
      return { type: "bundle", main: "BUNDLE", second: null };
    }

    const eligible = ALL_PRODUCTS.filter(function (p) {
      return p !== "IRON" || scores.IRON >= 4;
    }).sort(function (a, b) {
      return scores[b] - scores[a];
    });

    const main = eligible[0] || null;
    const secondCandidate = eligible[1] || null;
    const second =
      secondCandidate && scores[secondCandidate] >= 4 ? secondCandidate : null;

    return { type: "single", main: main, second: second };
  }

  /* ===========================================================================
   * 5. UI / STATE
   * ======================================================================== */
  function initQuiz(root) {
    // Merge Shopify product data with defaults + fallback URLs.
    const shopifyData = readShopifyProducts(root);
    const PRODUCTS = {};
    Object.keys(PRODUCT_DEFAULTS).forEach(function (key) {
      const sd = shopifyData[key] || {};
      const def = PRODUCT_DEFAULTS[key];
      PRODUCTS[key] = {
        name: sd.name || def.name,
        desc: sd.desc || def.desc,
        why: sd.why || def.why,
        image: sd.image || PLACEHOLDER_IMAGE,
        price: sd.price || "",
        url: sd.url || PRODUCT_URLS[key] || "#",
      };
    });

    const state = {
      index: 0,
      branch: null,
      answers: {}, // qid -> selection
      dir: "next", // navigation direction, drives the slide animation
    };

    const stage = root.querySelector("[data-quiz-stage]");
    const progressBar = root.querySelector("[data-quiz-progress-bar]");
    const prevBtn = root.querySelector("[data-quiz-prev]");
    const nextBtn = root.querySelector("[data-quiz-next]");
    const nav = root.querySelector("[data-quiz-nav]");

    /* ---- Build the active flow based on chosen branch ---- */
    function buildFlow() {
      const flow = [{ type: "intro" }];
      flow.push({ type: "question", q: QUIZ_DATA.goal });
      if (state.branch) {
        QUIZ_DATA.categories[state.branch].forEach(function (q) {
          flow.push({ type: "question", q: q });
        });
      }
      flow.push({ type: "question", q: QUIZ_DATA.safety });
      flow.push({ type: "result" });
      return flow;
    }

    function currentStep() {
      return buildFlow()[state.index];
    }

    /* ---- Render ---- */
    function render() {
      const flow = buildFlow();
      const step = flow[state.index];
      const outX = state.dir === "prev" ? 30 : -30;
      const inX = state.dir === "prev" ? -30 : 30;

      // animate the current screen out
      stage.style.transition = "";
      stage.classList.remove("is-visible");
      stage.style.opacity = "0";
      stage.style.transform = "translateX(" + outX + "px)";

      window.setTimeout(function () {
        stage.innerHTML = "";

        if (step.type === "intro") {
          renderIntro(stage);
        } else if (step.type === "question") {
          // question number = count of question steps up to here
          let qNumber = 0;
          for (let i = 0; i <= state.index; i++) {
            if (flow[i].type === "question") qNumber++;
          }
          renderQuestion(stage, step.q, qNumber);
        } else if (step.type === "result") {
          renderResult(stage);
        }

        updateProgress(flow);
        updateNav(flow, step);

        // place new screen on the entering side, then animate it in
        stage.style.transition = "none";
        stage.style.opacity = "0";
        stage.style.transform = "translateX(" + inX + "px)";
        void stage.offsetWidth; // force reflow
        stage.style.transition = "";
        stage.classList.add("is-visible");
        stage.style.opacity = "1";
        stage.style.transform = "translateX(0)";

        // move focus to heading for accessibility (no scroll jump)
        const h = stage.querySelector("[data-focus]");
        if (h) h.focus({ preventScroll: true });
      }, 200);
    }

    function updateProgress(flow) {
      // intro = 0%, result = 100%
      const total = flow.length - 1;
      const pct = total > 0 ? Math.round((state.index / total) * 100) : 0;
      progressBar.style.width = pct + "%";
      progressBar.parentElement.setAttribute("aria-valuenow", String(pct));
    }

    function updateNav(flow, step) {
      const isIntro = step.type === "intro";
      const isResult = step.type === "result";

      nav.style.display = isIntro || isResult ? "none" : "flex";
      // hide "back" on the first question so a single centered button shows
      prevBtn.style.display = state.index <= 1 ? "none" : "inline-flex";

      if (step.type === "question") {
        nextBtn.disabled = !hasAnswer(step.q);
        const isLastQuestion = flow[state.index + 1].type === "result";
        nextBtn.textContent = isLastQuestion ? "צפי בתוצאה" : "לשאלה הבאה";
      }
    }

    function hasAnswer(q) {
      const a = state.answers[q.id];
      if (q.type === "multi") return Array.isArray(a) && a.length > 0;
      return typeof a === "number";
    }

    /* ---- Screen: intro ---- */
    function renderIntro(el) {
      const wrap = document.createElement("div");
      wrap.className = "pq-intro";
      wrap.innerHTML =
        '<h1 class="pq-intro__title" tabindex="-1" data-focus>' +
        esc(QUIZ_DATA.intro.title) +
        "</h1>" +
        '<p class="pq-intro__subtitle">' +
        esc(QUIZ_DATA.intro.subtitle) +
        "</p>";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pq-btn pq-btn--primary pq-intro__cta";
      btn.textContent = QUIZ_DATA.intro.cta;
      btn.addEventListener("click", function () {
        goNext();
      });

      wrap.appendChild(btn);
      el.appendChild(wrap);
    }

    /* ---- Screen: question ---- */
    function renderQuestion(el, q, number) {
      const fieldset = document.createElement("fieldset");
      fieldset.className = "pq-question";

      const legend = document.createElement("legend");
      legend.className = "pq-question__legend";
      legend.setAttribute("tabindex", "-1");
      legend.setAttribute("data-focus", "");

      const titleWrap = document.createElement("span");
      titleWrap.className = "pq-question__title";

      const num = document.createElement("span");
      num.className = "pq-qnum";
      num.textContent = String(number);

      const txt = document.createElement("span");
      txt.className = "pq-question__text";
      txt.textContent = q.text;

      titleWrap.appendChild(num);
      titleWrap.appendChild(txt);
      legend.appendChild(titleWrap);
      fieldset.appendChild(legend);

      const list = document.createElement("div");
      list.className = "pq-options";

      const current = state.answers[q.id];

      q.options.forEach(function (opt, i) {
        const id = q.id + "_" + i;
        const isMulti = q.type === "multi";
        const checked = isMulti
          ? Array.isArray(current) && current.indexOf(i) !== -1
          : current === i;

        const label = document.createElement("label");
        label.className = "pq-option" + (checked ? " is-selected" : "");
        label.setAttribute("for", id);

        const input = document.createElement("input");
        input.type = isMulti ? "checkbox" : "radio";
        input.name = q.id;
        input.id = id;
        input.className = "pq-option__native";
        input.value = String(i);
        input.checked = checked;

        input.addEventListener("change", function () {
          selectOption(q, i);
          // re-render selection state without full fade
          Array.prototype.forEach.call(
            list.querySelectorAll(".pq-option"),
            function (lbl) {
              const inp = lbl.querySelector("input");
              lbl.classList.toggle("is-selected", inp.checked);
            }
          );
          updateNav(buildFlow(), { type: "question", q: q });
        });

        // letter badge (A / B / C / D ...)
        const badge = document.createElement("span");
        badge.className = "pq-option__badge";
        badge.setAttribute("aria-hidden", "true");
        badge.textContent = String.fromCharCode(65 + i);

        const text = document.createElement("span");
        text.className = "pq-option__label";
        text.textContent = opt.label;

        label.appendChild(input);
        label.appendChild(badge);
        label.appendChild(text);
        list.appendChild(label);
      });

      fieldset.appendChild(list);
      el.appendChild(fieldset);
    }

    /* ---- Selection logic ---- */
    function selectOption(q, i) {
      if (q.type === "multi") {
        const arr = Array.isArray(state.answers[q.id])
          ? state.answers[q.id].slice()
          : [];
        const pos = arr.indexOf(i);
        if (pos === -1) arr.push(i);
        else arr.splice(pos, 1);
        state.answers[q.id] = arr;
      } else {
        state.answers[q.id] = i;
        // goal question controls the branch
        if (q.id === QUIZ_DATA.goal.id) {
          const newBranch = q.options[i].branch || null;
          if (newBranch !== state.branch) {
            state.branch = newBranch;
            // clear answers from old category (keep goal + safety)
            pruneAnswers();
          }
        }
      }
    }

    // Remove answers that are no longer part of the active flow.
    function pruneAnswers() {
      const validIds = {};
      validIds[QUIZ_DATA.goal.id] = true;
      validIds[QUIZ_DATA.safety.id] = true;
      if (state.branch) {
        QUIZ_DATA.categories[state.branch].forEach(function (q) {
          validIds[q.id] = true;
        });
      }
      Object.keys(state.answers).forEach(function (qid) {
        if (!validIds[qid]) delete state.answers[qid];
      });
    }

    /* ---- Screen: result ---- */
    function renderResult(el) {
      const scores = computeScores(state.answers);
      const rec = recommend(scores);

      const wrap = document.createElement("div");
      wrap.className = "pq-result";

      const heading = document.createElement("h2");
      heading.className = "pq-result__heading";
      heading.setAttribute("tabindex", "-1");
      heading.setAttribute("data-focus", "");
      heading.textContent = "התוצאה האישית שלך";
      wrap.appendChild(heading);

      // main card
      wrap.appendChild(buildProductCard(PRODUCTS[rec.main], true));

      // second card
      if (rec.type === "single" && rec.second) {
        const sub = document.createElement("p");
        sub.className = "pq-result__subheading";
        sub.textContent = "השלמה אפשרית לשגרה";
        wrap.appendChild(sub);
        wrap.appendChild(buildProductCard(PRODUCTS[rec.second], false));
      }

      // disclaimer
      if (needsDisclaimer()) {
        const note = document.createElement("p");
        note.className = "pq-result__disclaimer";
        note.textContent = QUIZ_DATA.disclaimer;
        wrap.appendChild(note);
      }

      // restart
      const restart = document.createElement("button");
      restart.type = "button";
      restart.className = "pq-btn pq-btn--ghost pq-result__restart";
      restart.textContent = "התחילי מחדש";
      restart.addEventListener("click", function () {
        state.index = 0;
        state.branch = null;
        state.answers = {};
        render();
      });
      wrap.appendChild(restart);

      el.appendChild(wrap);
    }

    function buildProductCard(product, isMain) {
      const card = document.createElement("article");
      card.className = "pq-card" + (isMain ? " pq-card--main" : "");

      const img = document.createElement("img");
      img.className = "pq-card__image";
      img.src = product.image;
      img.alt = product.name;
      img.loading = "lazy";
      card.appendChild(img);

      const name = document.createElement("h3");
      name.className = "pq-card__name";
      name.textContent = product.name;
      card.appendChild(name);

      if (product.price) {
        const price = document.createElement("p");
        price.className = "pq-card__price";
        price.textContent = product.price;
        card.appendChild(price);
      }

      const desc = document.createElement("p");
      desc.className = "pq-card__desc";
      desc.textContent = product.desc;
      card.appendChild(desc);

      // "why this matches" — placeholder copy, enriched with saved answers
      const why = document.createElement("div");
      why.className = "pq-card__why";
      const whyTitle = document.createElement("p");
      whyTitle.className = "pq-card__why-title";
      whyTitle.textContent = "למה זה מתאים לך";
      why.appendChild(whyTitle);
      const whyText = document.createElement("p");
      whyText.className = "pq-card__why-text";
      whyText.textContent = product.why + buildAnswerNote();
      why.appendChild(whyText);
      card.appendChild(why);

      const link = document.createElement("a");
      link.className = "pq-btn pq-btn--primary pq-card__cta";
      link.href = product.url;
      link.textContent = "לצפייה במוצר";
      card.appendChild(link);

      return card;
    }

    // Build a small note from saved text-only / sleep answers.
    function buildAnswerNote() {
      const notes = [];
      Object.keys(state.answers).forEach(function (qid) {
        const q = QUESTION_INDEX[qid];
        if (q && q.saveText) {
          const opt = q.options[state.answers[qid]];
          if (opt) notes.push(opt.label);
        }
      });
      return notes.length ? " (מבוסס גם על: " + notes.join(", ") + ")" : "";
    }

    function needsDisclaimer() {
      const a = state.answers[QUIZ_DATA.safety.id];
      if (!Array.isArray(a)) return false;
      return a.some(function (i) {
        return QUIZ_DATA.safety.disclaimerIndexes.indexOf(i) !== -1;
      });
    }

    /* ---- Navigation ---- */
    function goNext() {
      const flow = buildFlow();
      if (state.index < flow.length - 1) {
        state.index += 1;
        render();
      }
    }
    function goPrev() {
      if (state.index > 0) {
        state.index -= 1;
        render();
      }
    }

    prevBtn.addEventListener("click", goPrev);
    nextBtn.addEventListener("click", function () {
      const step = currentStep();
      if (step.type === "question" && !hasAnswer(step.q)) return;
      goNext();
    });

    // first paint (render() handles the entrance animation)
    render();
  }

  /* ===========================================================================
   * 6. Helpers
   * ======================================================================== */
  function readShopifyProducts(root) {
    const node = root.querySelector("[data-quiz-products]");
    if (!node) return {};
    try {
      return JSON.parse(node.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function esc(str) {
    const d = document.createElement("div");
    d.textContent = str;
    return d.innerHTML;
  }

  /* ===========================================================================
   * 7. Boot — support multiple instances on a page.
   * ======================================================================== */
  function boot() {
    const roots = document.querySelectorAll("[data-product-quiz]");
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.quizInit === "1") return;
      root.dataset.quizInit = "1";
      initQuiz(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
